import React from 'react';
import DataList from '../../components/DataList';
import Typography from '../../components/Typography';
import Widget from '../../components/Widget/Widget';
import { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';
import './style.scss';

interface WidgetProps extends IClassNames {
  data: Record<string, string | number | boolean | undefined>;
}

const PersonalDataWidget: React.FC<WidgetProps> = ({ data, ...props }) => {
  return (
    <Widget
      title="personal_data.overview.title"
      description="personal_data.overview.description"
      ctaText="dashboard.widget.personalData.cta"
      ctaTo="/gegevens#persoonsgegevens"
      {...props}
    >
      <Typography variant="h3" as="h6" classNames="u-margin-bottom-xs">
        {translate('dashboard.widget.personalData.content.intro')}
      </Typography>
      <DataList data={data} />
    </Widget>
  );
};

export default PersonalDataWidget;
